"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.assign = tslib_1.__assign;
//# sourceMappingURL=utilities.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/foundation/lib-commonjs/utilities.js
// module id = 1043
// module chunks = 0